"use client";
import { usePathname } from "next/navigation";
import { Box, Card, Typography, CardContent } from "@mui/material";
import ContactSection from "./ContactSection";
import CustomLink from "../util/CustomLink";
import SectionHeader from "./SectionHeader";

const Contact = ({ type }) => {
  const pathname = usePathname();

  const typeDescriptions = {
    feedback: "Send us your feedback about your experience.",
    support: "Get support for pressing issues.",
    "bug-report": "Report any bugs you've encountered in our system.",
    "get-in-touch":
      "Reach out about partnership, investment, or other inquiries.",
    "enterprise-inquiry":
      "Enterprise plans, licensing, and onboarding for your organization.",
  };

  const renderContent = () => {
    if (pathname === "/contact") {
      return (
        <Box
          sx={{
            mt: 8,
            mx: { xs: 3, md: 6, lg: 24 },
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <SectionHeader title="Contact" textAlign="center" />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {[
              "feedback",
              "support",
              "bug-report",
              "get-in-touch",
              "enterprise-inquiry",
            ].map(
              (type, index) => (
                <Box key={index} sx={{ mb: 3, width: "48%" }}>
                  <Card
                    sx={{
                      minHeight: "200px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      boxShadow: 3,
                      borderRadius: 3,
                      border: "1px solid",
                      borderColor: "accents.superDark",
                      textDecoration: "none",
                      backgroundColor: "background.default",
                    }}
                    component={CustomLink}
                    href={`/contact/${type}`}
                    type="mui"
                  >
                    <CardContent
                      sx={{
                        minHeight: "150px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: { xs: "flex-start", md: "center" },
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontSize: { xs: "1.1rem", md: "1.3rem" },
                          fontWeight: "500",
                          textTransform: "capitalize",
                        }}
                      >
                        {type.replace(/-/g, " ")}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {typeDescriptions[type]}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              )
            )}
          </Box>
        </Box>
      );
    } else {
      return (
        <Box
          sx={{
            width: "100%",
            mt: 8,
            px: { xs: 2, sm: 4, md: 8, lg: 24 },
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography>
            <CustomLink href="/contact" style={{ color: "white" }} type="mui">
              Contact
            </CustomLink>{" "}
            / {type.replace(/-/g, " ")}
          </Typography>
          <ContactSection type={type} />
        </Box>
      );
    }
  };

  return <>{renderContent()}</>;
};

export default Contact;
